import { useState } from 'react';
import { catchBackendApiClient } from '../../../../client/customFetcher';
import useAnalyticsCalls from '@/hooks/use-analytics';

export function useDownloadLabResults() {
  const [isDownloading, setIsDownloading] = useState(false);
  const { callDownloadLabs } = useAnalyticsCalls();

  const downloadResults = async (orderId: string) => {
    if (!orderId) {
      console.error('No order ID provided for download');
      return;
    }

    setIsDownloading(true);
    try {
      // Track download analytics
      callDownloadLabs('results');
      const response = await catchBackendApiClient.get(
        `/v1/labs/orders/${orderId}/results`,
        { responseType: 'blob' }
      );

      // Create object URL and trigger download
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = `lab-results-${orderId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading lab results:', error);
      alert('Failed to download lab results. Please try again or contact support.');
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    downloadResults,
    isDownloading,
  };
}
